import { useNavigate, useParams } from "react-router-dom";
import { BLOG_LIST_ROUTE, BLOG_UPDATE_ROUTE } from "constants/routeEnum";
import callApi from "Common/utils/apiCaller";
import * as Yup from "yup";
import { useFormik } from "formik";
import { showNotification } from "Common/utils/Notification";
import { useEffect, useState } from "react";
import { TailSpin } from "react-loader-spinner";
import { imageUploader } from "Common/utils/imageUploader";
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import { getImageUrl } from "Common/utils/ImageDomain";
import PermissionSwitch from "../../Common/Components/PermissionLocks/PermissionSwitch";
import { ToastContainer } from "react-toastify";
import EditableView from "./EditableSegment";
import BreadCrumb from "Common/BreadCrumb";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import HtmlCode from "Common/Components/HtmlCode/HtmlCode";
import { X } from "lucide-react";
import Drawer from "Common/Components/Drawer";
import ImageView from "Common/Components/ImageView/ImageView";
import ReactSelect from "Common/Components/ReactSelect/ReactSelect";
import ImageData from "../../Common/Components/customImage/Image";
import LoaderComponent from "Common/Components/Loader/Loader";
import CustomInput from "Common/Components/InputFields/CustomInput";
import NewHtmlCode from "../../Common/Components/HtmlCode/NewHtmlCode";
import MetaData from "Common/MetaData";
import moment from "moment";
import CustomDateInput from "Common/Components/InputFields/CustomDateInput";
import BlogOrderModal from "pages/Blog/BlogOrderModal";

const segment_keys = ["blog_segments", "banner_segments"];
const UpdateBlog = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [pageType] = useState<any>("blog");
  const [CategoryId, setCategoryId] = useState<any>();
  const [staticCategory, setStaticCategory] = useState<any>();
  const [showApprove, setShowApprove] = useState<any>(false);
  const [imageLink, setImageLink] = useState<{
    media_url?: string;
    thumbnail_url?: string;
  } | null>(null);
  const [metaEdit, setMetaEdit] = useState<any>({
    url: "",
    page_title: "",
    meta_description: "",
    meta_keyword: "",
    canonical_url: "",
  });
  const [errors, setErrors] = useState<any>();
  const [version, setVersion] = useState<any>([]);
  const [segmentVersion, setSegmentVersion] = useState<any>([]);
  const [segmentData, setSegmentData] = useState<any>();
  const [blogInfo, setBlogInfo] = useState<any>([]);
  const [rankInfo, setRankInfo] = useState<any>([]);
  const [versionRankInfo, setVersionRankInfo] = useState<any>([]);
  const [bannerBlog, setBannerBlog] = useState<any>([]);
  const [newBanner, setNewBanner] = useState<any>([]);
  const [blogType, setBlogType] = useState<any>();
  const [content, setContent] = useState<any>();
  const [author, setAuthor] = useState<any>();
  const [blogData, setBlogData] = useState<any>();
  const [staticBlog, setStaticBlog] = useState<any>();
  const [authorList, setAuthorList] = useState<any>();
  const [authorId, setAuthorId] = useState<any>("");
  const [category, setCategory] = useState([]);
  const [authorDetail, setAuthorDetail] = useState<any>();
  const [showMeta, setShowMeta] = useState<any>(false);
  const toggleMeta = () => setShowMeta(!showMeta);
  const [loading, setLoading] = useState<any>(false);
  const [loader, setLoader] = useState<any>(false);
  const [imageData, setImageData] = useState<any>("");
  const [showImage, setShowImage] = useState<any>(false);
  const toggleImage = () => setShowImage(!showImage);
  const [collapse, setCollapse] = useState([]);
  const [formData, setFormData] = useState<any>({ released_at: "" });
  const [isOrderVisible, setIsOrderVisible] = useState(false);

  useEffect(() => {
    if (imageData && imageData?.media_url) {
      if (imageData?.content_type?.split("/")[0] === "image") {
        setImageLink(imageData);
      } else {
        showNotification("Please select Image", "error");
      }
    }
  }, [imageData]);

  const selectProperties = createSelector(
    (state: any) => state.Login,
    (profile) => ({
      permission: profile.permission,
      user: profile.user,
    })
  );

  const { permission, user } = useSelector(selectProperties);

  const handleshowSagment = (index) => {
    if (collapse.some((item) => item === index)) {
      setCollapse(collapse.filter((item) => item !== index));
    } else {
      let array = [...collapse];
      array.push(index);
      setCollapse(array);
    }
  };

  // Handle deleting a segment
  const handleDelete = async (Id, type) => {
    try {
      const bannerSegmentResult = await callApi(
        `v1/blog/${id}/segment/${Id}/remove-segment`,
        "post",
        { segment_type: type }
      );

      if (bannerSegmentResult.status === "Success") {
        setLoader(!loader);
        showNotification(" Removed segment successfully", "success");
      } else {
        // toast.error("Failed to remove segment");
      }
    } catch (error) {
      showNotification("Error removing segment", "error");
    }
  };

  const onAutherList = async () => {
    const localData = await callApi("v1/blog-author/list", "post", {
      pageNum: 1,
      pageSize: 100,
    });
    let arr = [];

    if (localData?.status === "Success") {
      for (let item of localData?.data.blog_authorList) {
        arr.push({ label: item.name, value: item.name });
      }
      // arr.push({ label: "Select author name", value: "Select..." });
      setAuthorList(arr);
      setAuthor(localData?.data?.blog_authorList);
    }
  };

  useEffect(() => {
    if (!authorList) {
      onAutherList();
    }
  }, [authorList]);
  useEffect(() => {
    fetchCategory();
  }, []);
  const fetchCategory = async () => {
    const localData = await callApi("v1/blog-category/list", "post", {
      filters: {
        // is_internal_user: true,
      },
    });

    if (localData?.status === "Success") {
      setCategory(
        localData.data.blog_categoryList.map((item) => {
          return {
            label: item.name,
            value: item.slug,
          };
        })
      );
    }
    // console.log(localData.data.blog_categoryList);
  };

  const handleAuthorList = (keyname, selectedOption: any) => {
    if (selectedOption.value === "Select...") {
      setAuthorId("");
    } else {
      for (let item of author) {
        if (item.name === selectedOption.value) {
          setAuthorId(item._id);
        }
      }
    }
    setAuthorDetail(selectedOption);
  };

  const handlePublish = async (url: any) => {
    try {
      const res = await callApi(`v1/blog/${url}/publish-blog`, "get", {});
      if (res && res?.status === "Success") {
        showNotification("Published successfully", "success");
        fetchBlog(blogData?.url);
        setShowApprove(false);
        fetchPodcast(id);
      }
    } catch (e) {
      showNotification(
        e.response.data.data.message || "Error occured",
        "error"
      );
    }
  };

  const userHasPermissionToEditPage = () => {
    return permission?.permissions?.includes("blog:edit");
  };

  const userHasPermissionToApprovePage = () => {
    return permission?.permissions?.includes("blog:verify");
  };

  const userHasPermissionToPublishPage = () => {
    return permission?.permissions?.includes("blog:publish");
  };

  const handleMetaChange = (keyName, keyValue) => {
    setMetaEdit((prev) => ({
      ...prev,
      [`updated_${keyName}`]: keyValue,
      is_meta_edited: true,
    }));
    setErrors((prev) => ({
      ...prev,
      [`updated_${keyName}`]: "",
    }));
  };


  const handleValidate = (data: any) => {
    let isValid = true;
    let error: { [index: string]: any } = {};
    if (!data?.url || data?.url === "") {
      isValid = false;
      error["url"] = "Please enter url";
    }
    // if (!data?.canonical_url || data?.canonical_url === "") {
    //   isValid = false;
    //   error["canonical_url"] = "Please enter canonical url";
    // }
    if (!data?.page_title || data?.page_title === "") {
      isValid = false;
      error["page_title"] = "Please enter page title";
    }
    if (!data?.meta_description || data?.meta_description === "") {
      isValid = false;
      error["meta_description"] = "Please enter meta description";
    }
    // if (!data?.meta_keyword || data?.meta_keyword === "") {
    //   isValid = false;
    //   error["meta_keyword"] = "Please enter meta keyword";
    // }
    return {
      isValid,
      error,
    };
  };

  const handleMetaData = async () => {
    let check = handleValidate(metaEdit);
    if (check.isValid) {
      try {
        const res = await callApi(
          `v1/blog/${blogData?.url}/update-blog`,
          "post",
          {
            blog: metaEdit,
          }
        );
        if (res && res?.status === "Success") {
          showNotification("Updated successfully", "success");
          toggleMeta();
        }
      } catch (e) {
        showNotification(
          e.response.data.data.message || "Error occured",
          "error"
        );
      }
    } else {
      setErrors(check.error);
    }
  };

  async function fetchPodcast(id: any) {
    try {
      const ress = await callApi(`v1/blog/${id}`, "get", {});
      if (ress && ress?.status === "Success") {
        const res = await callApi(
          `v1/blog/${ress?.data?.blog?.url}/blog-info`,
          "get",
          {}
        );
        if (res && res?.status === "Success") {
          setFormData((prev) => ({
            ...prev,
            released_at: res.data.details?.released_at,
          }));
          setImageLink(res.data.details);
          setBlogData(res.data.details);
          setMetaEdit(res.data.details);
          setStaticBlog({
            label: res.data.details.blog_type,
            value: res.data.details.blog_type,
          });
          setStaticCategory(
            res.data.details.blog_category?.map((item) => {
              return {
                label: item,
                value: item,
              };
            })
          );
          setContent(res.data.details.text);
          setAuthorId(res.data.details?.author_id);
          const response = await callApi(
            `v1/blog-author/${res.data.details?.author_id}`,
            "get"
          );
          if (response?.status === "Success") {
            setAuthorDetail({
              label: response.data.blog_author.name,
              value: response.data.blog_author.name,
            });
          }
        }
      }
    } catch (e) {
      showNotification("something went wrong", "error");
    }
  }
  useEffect(() => {
    if (id) {
      fetchPodcast(id);
    }
  }, [id]);

  const options = [
    { value: "Select...", label: "Select Blog Type" },
    { value: "blog", label: "blog" },
  ];

  const handleChange = (keyname, selectedOption: any) => {
    if (selectedOption.value === "Select...") {
      setBlogType("");
    } else {
      setBlogType(selectedOption.value);
    }
    setStaticBlog(selectedOption);
  };
  const handleCategory = (keyname, selectedOption: any) => {
    let arr = [];
    if (selectedOption.value === "Select...") {
      setCategoryId("");
    } else {
      for (let item of selectedOption) {
        arr.push(item.value);
      }
      setCategoryId(arr);
    }
    setStaticCategory(selectedOption);
  };

  const handleAddSegment = async () => {
    try {
      const res = await callApi(`v1/blogSegment/new`, "post", {
        blogSegment: {
          heading: "",
          text: "",
        },
      });

      if (res?.status === "Success") {
        const response = await callApi(
          `v1/blog/${id}/blog-segment/${res?.data?.blogSegment?._id}/add-segment`,
          "post",
          {}
        );
        if (response?.status === "Success") {
          fetchBlog(blogData?.url);
          showNotification("Segment added successfully", "success");
        }
      }
    } catch (e) {
      showNotification("Error occured", "error");
    }
  };
  const handleBannerSegment = async () => {
    try {
      const res = await callApi(`v1/normalBanner/new`, "post", {
        bannerSegmentTwo: {
          page_id: id,
          banner_image_url: "",
          banner_header_text: "",
          banner_sub_header_text: "",
        },
      });
      if (res?.status === "Success") {
        const response = await callApi(
          `v1/blog/${id}/banner-segment/${res?.data?.bannerSegmentTwo?._id}/add-segment`,
          "post",
          {}
        );
        if (response?.status === "Success") {
          showNotification("Banner segment added successfully", "success");
          fetchBlog(blogData?.url);
        }
      }
    } catch (e) {
      showNotification("Error occured", "error");
    }
  };
  async function fetchBlog(url) {
    try {
      const res = await callApi(`v1/blog/${url}/blog-info`, "get", {});

      if (res?.status === "Success") {
        const { banner_segments = [], blog_segments = [] } = res.data.details;

        // Formatting into the required structure
        const formattedSegments = [
          ...blog_segments.map((segment) => ({
            segment_type: "blog_segments",
            _id: segment._id,
          })),
        ];
        const bannerSegments = [
          ...banner_segments.map((segment) => ({
            segment_type: "banner_segments",
            _id: segment._id,
          })),
        ];
        let newSegmentData = [];
        let newBanner = [];
        let page = res.data.details;
        ["blog_segments"]?.forEach((segmentKey) => {
          if (page[segmentKey] && page[segmentKey].length > 0) {
            page[segmentKey].forEach((pageSegment) => {
              newSegmentData[pageSegment._id] = {
                data: pageSegment,
                segment_type: segmentKey,
              };
            });
          }
        });
        let pages = res.data.details;
        ["banner_segments"]?.forEach((segmentKey) => {
          if (page[segmentKey] && pages[segmentKey].length > 0) {
            page[segmentKey].forEach((pageSegment) => {
              newBanner[pageSegment._id] = {
                data: pageSegment,
                segment_type: segmentKey,
              };
            });
          }
        });
        setBannerBlog(bannerSegments);
        setSegmentData(newSegmentData);
        setNewBanner(newBanner);
        setBlogInfo(formattedSegments);
        setRankInfo(blog_segments)
      }
    } catch (e) {
      showNotification("Error occured", "error");
    }
  }
  useEffect(() => {
    if (blogData?.url) {
      fetchBlog(blogData?.url);
    }
    if (id) fetchVersionList(id);
    if (id) fetchSegmentVersion(id);
  }, [blogData?.url, loader, id]);

  const fetchSegmentVersion = async (id) => {
    try {
      const res = await callApi(`v1/blog/${id}/version-list`, "post", {});
      if (res && res?.status === "Success") {
        let copyObject = {};
        let copyDocuments = res.data?.documents;
        copyDocuments.forEach((objectItem) => {
          copyObject[objectItem.original_id] = objectItem;
        });
        setSegmentVersion(copyObject);



        setVersionRankInfo(res.data?.documents)
      }
    } catch (e) { }
  };

  const fetchVersionList = async (id) => {
    try {
      const res = await callApi(`v1/blog/${id}/version-list-blog`, "get", {});
      if (res && res?.status === "Success") {
        setVersion(res.data?.copies);
      }
    } catch (e) { }
  };

  const hasEditMode = () => {
    return blogData?.is_edit;
  };

  const hasApproved = () => {
    return blogData?.is_approved;
  };
  // validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      heading: blogData?.heading,
    },
    validationSchema: Yup.object({
      heading: Yup.string().required("Please Enter heading"),
    }),

    onSubmit: async (values) => {
      const updateData = {
        ...values,
      };
      if (!!!imageLink?.media_url && !!!imageLink?.thumbnail_url) {
        showNotification("Please add image");
        return;
      }
      if (!!!authorId) {
        showNotification("Please select author", "error");

        return;
      }
      if (!!!formData.released_at) {
        showNotification("Please select release date", "error");

        return;
      }
      // update user
      if (blogData?.url) {
        try {
          setLoading(true);
          const res = await callApi(
            `v1/blog/${blogData?.url}/update-blog`,
            "post",
            {
              ...values,
              blog_type: blogType || staticBlog?.value,
              thumbnail_url: imageLink?.media_url || imageLink?.thumbnail_url,
              text: content,
              author_id: authorId,
              blog_category: CategoryId,
              url: blogData?.url,
              ...formData,
            }
          );
          setLoading(false);
          if (res && res?.status === "Success") {
            showNotification("Updated successfully", "success");
            setLoading(true);
            fetchPodcast(id);
            setTimeout(() => {
              setLoading(false);
              navigate(BLOG_LIST_ROUTE);
            }, 800);
          }
        } catch (e) {
          showNotification("something went wrong", "error");
        }
      }
    },
  });
  const handleApprove = async () => {
    if (!blogData) {
      showNotification("Page data is missing. Please try again.", "error");
      return;
    }
    try {
      const response = await callApi(
        `v1/blog/url/${blogData?.url}/approve`,
        "get"
      );
      if (response?.status === "Success") {
        setLoader(!loader);
        showNotification("Page approved successfully", "success");

        fetchBlog(blogData?.url);
        fetchPodcast(id);
        setShowApprove(true);
      }
    } catch (error) {
      showNotification(
        "An error occurred while publishing the page. Please try again.",
        "error"
      );
    }
  };
  const getVersionCopyData = (item) => {
    return item._id && segmentVersion[item._id]
      ? {
        ...segmentVersion[item._id],
        segment_type: item.segment_type,
      }
      : null;
  };
  const getSegmentData = (item) => {
    return item._id &&
      segmentData &&
      segmentData[item._id] &&
      segmentData[item._id].data
      ? {
        ...segmentData[item._id].data,
        segment_type: item.segment_type,
      }
      : null;
  };
  const getSegmentDatas = (item) => {
    return item._id &&
      newBanner &&
      newBanner[item._id] &&
      newBanner[item._id].data
      ? {
        ...newBanner[item._id].data,
        segment_type: item.segment_type,
      }
      : null;
  };
  const getVersionCopyDatas = (item) => {
    return item._id && segmentVersion[item._id]
      ? {
        ...segmentVersion[item._id],
        segment_type: item.segment_type,
      }
      : null;
  };
  // console.log(segmentVersion, "err");

  const showError = (keyName) => {
    return errors && errors[keyName] ? (
      <p className="text-red-500 text-[14px]  pt-2">{errors[keyName]}</p>
    ) : null;
  };

  const toLocalMidnightDate = (isoStr) => {
    if (!isoStr) return "";
    const m = moment(isoStr).local(); // convert UTC to local
    return new Date(m.year(), m.month(), m.date()); // local midnight Date object
  };

  const formatDateOnly = (date) => {
    return moment(date).format("YYYY-MM-DD");
  };

  return (
    <>
      <div className="flex justify-between mt-2">
        <BreadCrumb
          title={`/blog/${id}/update`}
          pageTitle={BLOG_LIST_ROUTE}
          version="v1"
        />
        <div>
          {userHasPermissionToApprovePage() &&
            hasEditMode() &&
            !showApprove && (
              <div
                className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                onClick={handleApprove}
              >
                Approve
              </div>
            )}
          {userHasPermissionToPublishPage() && showApprove && hasApproved() && (
            <button
              type="button"
              className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              onClick={() => {
                handlePublish(blogData?.url);
              }}
            >
              <span className="align-middle">Publish</span>
            </button>
          )}
          <button
            type="button"
            className="ml-2 text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
            onClick={() => toggleMeta()}
          >
            <span className="align-middle">Edit Meta</span>
          </button>
          <div
            onClick={() => setIsOrderVisible(true)}
            className="ml-2 text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
          >
            Edit Order
          </div>
        </div>
      </div>
      <ToastContainer />
      {bannerBlog?.map((item, index) => (
        <EditableView
          segmentType={item?.segment_type}
          key={index}
          loader={loader}
          setLoader={setLoader}
          handleshowSagment={() => handleshowSagment(index)}
          segment_id={item?._id}
          data={getSegmentDatas(item)}
          versionData={getVersionCopyDatas(item)}
          pageId={id}
          collapse={collapse}
          index={index}
          handleDelete={handleDelete}
          pageType={pageType}
          isEditable={userHasPermissionToEditPage()}
        />
      ))}
      <div className="grid grid-cols-12 gap-x-5">
        <div className="col-span-12 card 2xl:col-span-12">
          <div className="p-6">
            <form
              className="create-form"
              id="create-form"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <input type="hidden" value="" name="id" id="id" />
              <input type="hidden" value="add" name="action" id="action" />
              <input type="hidden" id="id-field" />
              <div
                id="alert-error-msg"
                className="hidden px-4 py-3 text-sm text-red-500 border border-transparent rounded-md bg-red-50 dark:bg-red-500/20"
              ></div>
              <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                <div className="xl:col-span-12">
                  <div className="m-4 ml-0 xl:col-span-12">
                    {imageLink ? (
                      <div className="flex items-center">
                        <ImageData
                          imageLink={imageLink}
                          setImageLink={setImageLink}
                          setImageData={setImageData}
                        />
                        <div className="h-3 ml-3">
                          <label
                            onClick={() => {
                              setImageData(undefined);
                              toggleImage();
                            }}
                            className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                          >
                            Change
                          </label>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div
                          onClick={() => {
                            setImageData(undefined);
                            toggleImage();
                          }}
                          className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                        >
                          {"Add Image"}
                        </div>
                      </>
                    )}
                  </div>
                  <label
                    htmlFor="phoneNumberInput3"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Blog
                  </label>
                  <ReactSelect
                    options={options}
                    isSearchable={true}
                    isMulti={false}
                    placeholder={"Please select blog type"}
                    contentType={staticBlog}
                    handleContentChange={handleChange}
                    name={"blog_type"}
                    id={"blog-type11"}
                    versionData={{
                      label: version?.blog_type,
                      value: version?.blog_type,
                    }}
                  />
                </div>
                <div className="xl:col-span-12">
                  <CustomInput
                    label="Heading"
                    name="heading"
                    type="text"
                    value={validation.values.heading}
                    placeholder="Enter heading"
                    onChange={validation.handleChange}
                    isVersioned={version ? true : false}
                    versionedValue={version?.heading}
                  />

                  {validation.touched.heading && validation.errors.heading ? (
                    <p className="text-red-400">{validation.errors.heading}</p>
                  ) : null}
                </div>
                <div className="xl:col-span-12">
                  <label
                    htmlFor="phoneNumberInput1"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Author
                  </label>
                  <div className="xl:col-span-2">
                    {authorList ? (
                      <ReactSelect
                        options={authorList}
                        isSearchable={true}
                        isMulti={false}
                        placeholder={"Please select author"}
                        contentType={authorDetail}
                        handleContentChange={handleAuthorList}
                        name={"author"}
                        id={"author11"}
                        versionData={{
                          value: author?.find(
                            (item) => item._id === version?.author_id
                          )?.name,

                          label: author?.find(
                            (item) => item._id === version?.author_id
                          )?.name,
                        }}
                      />
                    ) : null}
                  </div>
                </div>
                <div className="xl:col-span-12">
                  <CustomDateInput
                    // value={formData?.released_at ? moment(new Date(formData?.released_at)).toISOString()
                    //     : "" } // Default to empty string if undefined
                    value={toLocalMidnightDate(formData?.released_at)} // pass local midnight Date
                    setDate={(selectedDates) => {
                      if (selectedDates && selectedDates[0]) {
                        // Save only date string YYYY-MM-DD to avoid timezone shifts
                        setFormData(prev => ({
                          ...prev,
                          released_at: formatDateOnly(selectedDates[0])
                        }));
                      }
                    }}
                    dateOptions={{ dateFormat: "Y-m-d" }}
                    isRequired={true}
                    keyName="released_at"
                    label="Release Date"
                    // setDate={(selectedDates) => {
                    //   if (selectedDates && selectedDates[0]) {
                    //     setFormData((prev) => ({
                    //       ...prev,
                    //       released_at: selectedDates[0].toISOString(),
                    //     }));
                    //   }
                    // }}
                    isVersioned={!!version?.released_at} // Only true if version.released_at is defined
                    versionedValue={
                      version?.released_at
                        ? moment(new Date(version.released_at)).toISOString()
                        : ""
                    } // Default empty string if not defined
                    placeholder="Select Date"
                    errors={""}
                  />
                </div>
                <div className="w-64 md:w-[700px] xl:col-span-12">
                  <label className="inline-block mb-2 text-base font-medium">
                    Category
                  </label>

                  <ReactSelect
                    options={category}
                    isSearchable={false}
                    isMulti={true}
                    placeholder={"Please select category"}
                    contentType={staticCategory}
                    handleContentChange={handleCategory}
                    name={"category_type"}
                    id={"category-type11"}
                    versionData={
                      version?.blog_category?.length > 0
                        ? version.blog_category?.map((item) => {
                          return {
                            label: item.replace("-", " "),
                            value: item,
                          };
                        })
                        : null
                    }
                  />
                </div>
                <div className="mb-6 xl:col-span-12">
                  <NewHtmlCode
                    content={content}
                    setContent={setContent}
                    label={"Text"}
                    isVersioned={version?.text ? true : false}
                    versionedValue={version?.text}
                  />
                </div>
              </div>

              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="reset"
                  id="close-modal"
                  data-modal-close="addEmployeeModal"
                  className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                  onClick={() => navigate(BLOG_LIST_ROUTE)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  id="addNew"
                  style={{
                    minWidth: "130px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                  {loading ? <LoaderComponent /> : "Update Blog"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {blogInfo?.map((item, index) => (
        <EditableView
          segmentType={item?.segment_type}
          key={index}
          loader={loader}
          setLoader={setLoader}
          handleshowSagment={() => handleshowSagment(index)}
          segment_id={item?._id}
          data={getSegmentData(item)}
          versionData={getVersionCopyData(item)}
          pageId={id}
          collapse={collapse}
          index={index}
          handleDelete={handleDelete}
          pageType={pageType}
          isEditable={userHasPermissionToEditPage()}
        />
      ))}
      <div className="flex flex-col mb-2 ">
        <div
          onClick={() => {
            handleAddSegment();
          }}
          className="w-[200px] mb-2 text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
        >
          {"Add Blog Segment"}
        </div>
        {!bannerBlog.some(
          (item) => item.segment_type === "banner_segments"
        ) && (
            <div
              onClick={() => {
                handleBannerSegment();
              }}
              className="w-[200px] mt-2 text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
            >
              {"Add Banner Segment"}
            </div>
          )}
      </div>
      <Drawer
        show={showMeta}
        onHide={toggleMeta}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Edit"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <MetaData
            handleMetaChange={handleMetaChange}
            modelName="blog"
            metaEdit={metaEdit}
            showError={showError}
            toggleMeta={toggleMeta}
            handleMetaData={handleMetaData}
            loader={loader}
          />
        </Drawer.Body>
      </Drawer>
      <Drawer
        show={showImage}
        onHide={toggleImage}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Icon"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showImage}
            setEventData={setImageData}
            togleImage={toggleImage}
          />
        </Drawer.Body>
      </Drawer>


      <BlogOrderModal
        isVisible={isOrderVisible}
        onClose={() => setIsOrderVisible(false)}
        loader={loader}
        setLoader={setLoader}
        getSegmentData={versionRankInfo.length > 0 ? versionRankInfo :  rankInfo}
      />
    </>
  );
};

export default UpdateBlog;
